import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const taxRatesTitle = 'Tax Rates';
const taxTablesTitle = 'Tax Tables';

const taxRoutes: RouteObject[] = [
  {
    path: '/tax/rates',
    element: lazyElement(() => import('./Main')),
    handle: {
      documentTitle: taxRatesTitle,
      crumb: () => ({ label: taxRatesTitle, to: '/tax/rates' }),
    },
  },
  {
    path: '/tax/tables',
    element: lazyElement(() => import('./TaxTables')),
    handle: {
      documentTitle: taxTablesTitle,
      crumb: () => ({ label: taxTablesTitle, to: '/tax/tables' }),
    },
  },
];

export default taxRoutes;

